<template>
  <div class="transfer">
    <div class="transfer__header">
      <div>
        <i @click="back" class="fas fa-arrow-left" v-if="transferType !== 'assisted'"></i>
        <h3>Transferir llamada</h3>
      </div>
      <div class="transfer__header-buttons-container">
        <hold-button v-if="transferType === 'assisted'" :state="currentCall.hold" class="button" @hold="$emit('hold')" @unhold="$emit('unhold')"/>
      </div>
    </div>
    <div class="transfer__template-wraper" v-if="!transferType">
      <slot name="transfer-template">
        <div class="transfer__template-content-default">
          <el-input v-model="number" type="text" @keypress.native="handlePress"></el-input>
          <div class="transfer__keypad">
            <the-button v-for="(button,i) in buttons" :key="i" :value="button.value" @click.native="onClick(button)"></the-button>
          </div>
        </div>
      </slot>
    </div>
    <div class="transfer__template-content-default" v-else>
      <el-input v-model="number" type="text" @keypress.native="handlePress"></el-input>
        <div class="transfer__keypad">
          <the-button v-for="(button,i) in buttons" :key="i" :value="button.value" @click="onClick(button)"></the-button>
        </div>
    </div>
    <div v-if="!transferType" class="transfer__transfer-buttons">
      <el-button class="transfer__transfer-assist-button" @click="assitedTransfer">Primero preguntar</el-button>
      <el-button class="transfer__transfer-now-button" type="success" @click="bindTransfer">Transferir ahora</el-button>
    </div>
    <div v-else-if="transferType === 'assisted'" class="transfer__transfer-buttons">
      <el-button class="transfer__transfer-go-back-button" @click="goBackToCall">Volver a la llamada</el-button>
      <el-button class="transfer__transfer-now-button" type="success" @click="hangup">Tranferir ahora</el-button>
    </div>
  </div>
</template>
<script>
const AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext;
import Tone from "@/plugins/tone";
import TheButton from '@/components/softphone/TheButton.vue';
import {EventBus} from '@/plugins/event-bus.js'
import HoldButton from '@/components/softphone-widget/HoldButton.vue';
export default{
  props: {
    currentCall: {
      type: Object,
      required: true
    }
  },
  components: {
    TheButton,
    HoldButton
  },
  data(){
    TheButton
    return {
      number : '',
      dtmf: new Tone(new AudioContext(), 350, 440),
      buttons : [
        {value: "1", active : false, f1: 697, f2: 1209 },
        {value: "2", text: 'abc', active : false, f1: 697, f2: 1336 },
        {value: "3", text: 'def', active : false, f1: 697, f2: 1477 },
        {value: "4", text: 'ghi', active : false, f1: 770, f2: 1209 },
        {value: "5", text: 'jkl', active : false, f1: 770, f2: 1336 },
        {value: "6", text: 'mno', active : false, f1: 770, f2: 1477 },
        {value: "7", text: 'pqrs',active : false, f1: 852, f2: 1209 },
        {value: "8", text: 'tuv', active : false, f1: 852, f2: 1336 },
        {value: "9", text: 'vwxyz', active : false, f1: 852, f2: 1477 },
        {value: "*", text: '', active : false, f1: 941, f2: 1209 },
        {value: "0", text: '+', active : false, f1: 941, f2: 1336 },
        {value: "#", text: '', active : false, f1: 941, f2: 1477}
      ],
      transferType: null,
    }
  },
  methods: {
    back(){
      this.$emit('back');
    },
    onClick(button) {
      this.number += button.value;

      this.$emit('send-dtmf', button.value);
      
    },
    playTone(button) {
      if(this.transferType === 'assisted'){
        this.$emit('send-dtmf', button.value);
      }
      this.dtmf.freq1 = button.f1;
      this.dtmf.freq2 = button.f2;

      if (this.dtmf.status == 1) {
       this.dtmf.stop();
      }

      if (this.dtmf.status == 0) {
        this.dtmf.start();
      }

      setTimeout(() => {
        this.dtmf.stop();
      }, 250);
    },
    handlePress(evt) {
      const value = evt.key;
      const button = this.buttons.find(button => button.value == value)

      if (button){
        this.$emit('send-dtmf', button.value);
        
        button.active = true;
        this.buttons = this.buttons.map(btn => btn.value === value ? button : btn)
        setTimeout(() => {
          button.active = false;
          this.buttons = this.buttons.map(btn => btn.value === value ? button : btn)
        }, 250)
      }
    },
    assitedTransfer(){
      this.transferType = 'assisted';
      this.$emit('assisted-transfer', this.number);
    },
    bindTransfer(){

      this.transferType = null;
      this.$emit('bind-transfer', this.number);
    },
    goBackToCall(){
      this.transferType = null;
      this.$emit('go-back-to-call');
    },
    hangup(){
      this.transferType = null;
      this.$emit('hangup');
    }
  },
  created(){
    EventBus.$on('select-destination-transfer', (destination) => {
      this.number = destination;
    })

    EventBus.$on('digit-destination', (digits)=>{
      this.number = digits;
    })
  }
}
</script>
<style scoped>
.transfer{
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}
.fa-arrow-left{
  color: var(--hiperpbx-green);
  font-size: 20px;
  cursor: pointer;
}
.transfer__header{
  display: flex;
  flex-direction: column;
  gap: 10px;

}
.transfer__header-buttons-container{
  display: flex;
  justify-content: center;
}
.transfer__keypad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: var(--column);
  grid-auto-rows: minmax(10px, auto);
  justify-items: center;
}
.transfer__number-display {
  margin-bottom: var(--column);
}
.transfer__template-content-default{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.transfer__number-display :deep(.el-input__inner) {
  font-size: 20px;
  color: var(--hiperpbx-green);
  font-weight: bold;
}
.transfer__transfer-buttons{
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.transfer__transfer-now-button{
  width: 100%;
  margin: 0 !important;
}

.transfer__transfer-assist-button{
  width: 100%;
}
</style>